import React from 'react';
import { useSelectStandardTemplateMilestoneFieldQuery } from 'generated/graphql';

export type IData = {
  id: string;
  name: string;
  displayName: string;
};

export function useQuery() {
  const tuple = useSelectStandardTemplateMilestoneFieldQuery();

  return React.useMemo(
    () => {
      const data: IData[] = tuple.data?.standardTemplateMilestones?.map((node) => ({
        id: node?.id ?? '',
        name: node?.id ?? '',
        displayName: node?.title ?? ''
      }
      )) ?? [];

      return {
        ...tuple,
        data
      };
    }
    , [tuple]
  );
}
